export const listBeams = state => state.beams.allBeams;

export const listBeamsFromOrbitalPosition = (state, orbitalPositionId) => state.beams.allBeams.filter(b => b.orbital_position_id === orbitalPositionId);

export const showBeam = (state, beamId) => state.beams.allBeams.find(beam => beam.id === beamId);

export const getTotalCount = state => state.beams.totalCount;

export const listBeamsFilters = state => state.beams.filters;
